import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnChanges,
  OnInit,
  PLATFORM_ID,
  SimpleChanges,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedUserService } from '../../services/shared/user/shared-user.service';
import {
  faHeadset,
  faSignOutAlt,
  faUserCircle,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { loadComponentTranslations } from '../../funcs/lang-loader';
import { HttpClient } from '@angular/common/http';
import { IUser } from '../../models/dtos/get/user.interface';
import { UserCircleComponent } from '../user-circle/user-circle.component';

@Component({
  selector: 'app-navbar-control',
  imports: [
    FontAwesomeModule,
    RouterModule,
    NgbDropdownModule,
    TranslateModule,
    UserCircleComponent,
  ],
  templateUrl: './navbar-control.component.html',
  styleUrl: './navbar-control.component.scss',
})
export class NavbarControlComponent implements OnInit {
  public faUserCircle: IconDefinition = faUserCircle;
  public isLoggedIn: boolean = false;
  public user: IUser = null!;

  constructor(
    private _sharedUserService: SharedUserService,
    private _changeDetectRef: ChangeDetectorRef,
    private _translateService: TranslateService,
    private _http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  public ngOnInit(): void {
    this.subscribeUserService();

    loadComponentTranslations(
      this._http,
      this._translateService,
      'controls/navbar-control',
      this.isBrowser(),
    ).subscribe({
      next: () => {
        console.log('Translation loaded successfully after language change.');
        this._changeDetectRef.detectChanges();
      },
      error: (err) => console.error('Failed to load translation:', err),
    });
  }

  private subscribeUserService(): void {
    this._sharedUserService.loggedIn$.subscribe((response) => {
      if (response?.user) {
        console.log('User email:', response.user.email);
        this.user = response.user;
      }
      this.isLoggedIn = response ? true : false;
      this._changeDetectRef.detectChanges();
    });
  }
}
